import { useState } from "react";
import FloatingCTA from "components/blocks/FloatingCTA";
import ImageVideoText from "components/sections/ImageVideoText";
import HorizontalTechSpecs from "components/sections/HorizontalTechSpecs";
// import VerticalTechSpecs from "components/sections/VerticalTechSpecs";
import TextImageColumns from "components/sections/TextImageColumns";
import TextColumns from "components/sections/TextColumns";
import BigTitleSection from "components/sections/BigTitleSection";
import DarkQuoteSection from "components/sections/DarkQuoteSection";
import TextHeader from "components/sections/TextHeader";
import NavFooter from "components/sections/NavFooter";
import MainContainer from "components/sections/MainContainer";
import MetaHead from "components/base/MetaHead";
import Trans from "components/base/Trans";
import Wide from "components/icons/Wide";
import Seat from "components/icons/Seat";
import Climate from "components/icons/Climate";
import Bluetooth from "components/icons/Bluetooth";
import SliderSection from "components/sections/SliderWithThumbsSection";
import { useShowCTA } from "utils/hooks";

export default function Interiors() {
  const [lastSectionVisible, setLastSectionVisible] = useState(false);
  const { headerRef, showCTA } = useShowCTA(lastSectionVisible);

  return (
    <MainContainer
      navStyle={{ gradient: false, inverted: false }}
      updateVisible={setLastSectionVisible}
    >
      <MetaHead
        title="LBL_INTERIOR_META_TITLE"
        keywords={["LBL_META_KEYWORD_3"]}
        description="LBL_INTERIOR_META_DESC"
        imageUrl="/images/meta/interior.jpg"
      />
      <div ref={headerRef}>
        <TextHeader
          page={<Trans id="LBL_INTERIOR_PAGE_TITLE" />}
          title={<Trans id="LBL_INTERIOR_TITLE" />}
          description={<Trans id="LBL_INTERIOR_DESCRIPTION" />}
          inverted
        />
      </div>
      {/* <VerticalTechSpecs /> */}
      <HorizontalTechSpecs
        height="100vh"
        image="/images/hdc/header.jpg"
        video={{
          stream: {
            type: "hls",
            data: "https://vz-49830c06-001.b-cdn.net/bf764722-8c35-493b-912a-5a71d01a98d0/playlist.m3u8",
          },
          metadata: {
            video_title: "Hill Helicopters Interior Concept Video",
            video_id: "interior-concept-video",
          },
        }}
        specs={[
          { text: <Trans id="LBL_INTERIOR_VERTICALSPEC_1" /> },
          { text: <Trans id="LBL_INTERIOR_VERTICALSPEC_2" /> },
          { text: <Trans id="LBL_INTERIOR_VERTICALSPEC_3" /> },
          { text: <Trans id="LBL_INTERIOR_VERTICALSPEC_4" /> },
          { text: <Trans id="LBL_INTERIOR_VERTICALSPEC_5" /> },
        ]}
      />
      <BigTitleSection
        title={<Trans id="LBL_INTERIOR_FLYING_TITLE" />}
        isWide
        description={<Trans id="LBL_INTERIOR_FLYING_DESCRIPTION" />}
        inverted
      />
      <ImageVideoText
        pt={0}
        pb={0}
        animationId="it-1"
        title={<Trans id="LBL_INTERIOR_EFFORTLESS_CAPTION_1" />}
        description={<Trans id="LBL_INTERIOR_EFFORTLESS_DESCRIPTION_1" />}
        image={{
          base: "/images/interiors/navigation-mobile.jpg",
          md: "/images/interiors/navigation.jpg",
        }}
        inverted
      />
      <TextImageColumns
        inverted
        animationId="tic-1"
        topTitle={<Trans id="LBL_INTERIOR_EXPERIENCE_TITLE" />}
        topDescription={<Trans id="LBL_INTERIOR_EXPERIENCE_DESCRIPTION" />}
        topImage={{
          base: "/images/interiors/interiors-01-mobile.jpg",
          md: "/images/interiors/interiors-01.jpg",
        }}
        bottomTitle={<Trans id="LBL_INTERIOR_STANDARDS_TITLE" />}
        bottomDescription={<Trans id="LBL_INTERIOR_STANDARDS_DESCRIPTION" />}
        bottomImage={{
          base: "/images/interiors/interiors-02-mobile.jpg",
          md: "/images/interiors/interiors-02.jpg",
        }}
      />
      {/* <Box360 url="https://cdn.hillhelicopters.com/images/interiors/panorama.jpg" />
      <Box360
        url="https://cdn.hillhelicopters.com/images/interiors/panorama.jpg"
        mobile
      /> */}
      <ImageVideoText
        animationId="it-2"
        title={<Trans id="LBL_INTERIOR_EFFORTLESS_CAPTION_2" />}
        description={<Trans id="LBL_INTERIOR_EFFORTLESS_DESCRIPTION_2" />}
        image={{
          base: "/images/interiors/flying-mobile.jpg",
          md: "/images/interiors/flying.jpg",
        }}
        inverted
        pb={0}
      />

      <TextColumns
        title={<Trans id="LBL_INTERIOR_DESIGN_TITLE" />}
        description={<Trans id="LBL_INTERIOR_DESIGN_DESCRIPTION" />}
        inverted
      />
      <HorizontalTechSpecs
        image={{
          base: "/images/interiors/interior-a-mobile.jpg",
          md: "/images/interiors/interior-a.jpg",
        }}
        specs={[
          {
            icon: <Wide color="white" />,
            text: <Trans id="LBL_INTERIOR_SPEC_1" />,
          },
          {
            icon: <Seat width="30px" height="42px" color="white" />,
            text: <Trans id="LBL_INTERIOR_SPEC_2" />,
          },
          {
            icon: <Climate color="white" />,
            text: <Trans id="LBL_INTERIOR_SPEC_3" />,
          },
          {
            icon: <Bluetooth color="white" />,
            text: <Trans id="LBL_INTERIOR_SPEC_4" />,
          },
        ]}
      />
      <DarkQuoteSection
        title={<Trans id="LBL_INTERIOR_MAGICCARPET_TITLE" />}
        description={<Trans id="LBL_INTERIOR_MAGICCARPET_DESCRIPTION" />}
      />
      <SliderSection
        images={[
          "/images/interiors/slider/13.jpg",
          "/images/interiors/slider/01.jpg",
          "/images/interiors/slider/02.jpg",
          "/images/interiors/slider/03.jpg",
          "/images/interiors/slider/04.jpg",
          "/images/interiors/slider/05.jpg",
          "/images/interiors/slider/06.jpg",
          "/images/interiors/slider/07.jpg",
          "/images/interiors/slider/08.jpg",
          "/images/interiors/slider/09.jpg",
          "/images/interiors/slider/10.jpg",
          "/images/interiors/slider/11.jpg",
          "/images/interiors/slider/12.jpg",
        ]}
        inverted
      />
      <NavFooter
        previous={<Trans id="LBL_MENU_EXTERIOR" />}
        next={<Trans id="LBL_MENU_ENGINE" />}
        pathPrevious="/exterior"
        pathNext="/gt50-engine"
        bgPrevious="/images/nav-footer/interior.jpg"
        bgNext="/images/navbar/navbar_gt50.jpg"
      />
      <FloatingCTA show={showCTA} />
    </MainContainer>
  );
}
